/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchTextExtension } from '../../models/search-text-extension';

export interface GetProductNamesAndBrands$Params {

/**
 * Search string given by the user in the product search field.
 */
  searchText: string;
}

export function getProductNamesAndBrands(http: HttpClient, rootUrl: string, params: GetProductNamesAndBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchTextExtension>>> {
  const rb = new RequestBuilder(rootUrl, getProductNamesAndBrands.PATH, 'get');
  if (params) {
    rb.query('searchText', params.searchText, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SearchTextExtension>>;
    })
  );
}

getProductNamesAndBrands.PATH = '/search/products/names-and-brands';
